import Head from "next/head";
import Link from "next/link";

import { Col, Container, Dropdown, Row } from "react-bootstrap";

import { getCategories, getProducts } from "../../api/db/products";
import { transformProduct } from "../../libs/tranforms";

import ProductCard from "../../components/ProductCard";
import SEO from "../../components/SEO";
import Breadcrumbs from "../../components/layout/Breadcrumbs";

import styles from "../../styles/shop.module.scss";

const Products = ({ products, category, categoryPath, categoryChildren }) => {
  const buildUrl = (params) => {
    let url = "/sklep";
    if (category) {
      url += `/${category.slug}`;
    }
    if (params.category) {
      url += `/${params.category.slug}`;
    }
    return url;
  };

  const parts = categoryPath.reduce(
    (p, c) => {
      p.path.push({
        href: `${p.lastPart}/${c.slug}`,
        name: c.name,
      });
      p.lastPart += "/" + c.slug;
      return p;
    },
    { path: [], lastPart: "/sklep" }
  ).path;

  return (
    <>
      <Head>{SEO([category.name, "sklep"])}</Head>
      <Breadcrumbs
        parts={parts}
        background={category.image}
        title={category.name}
        description={category.description}
      />
      <Container fluid className={styles.container}>
        <Row className="mb-3">
          <Col>
            {categoryChildren.length > 0 && (
              <Dropdown>
                <Dropdown.Toggle variant="primary">Kolekcje</Dropdown.Toggle>

                <Dropdown.Menu variant="dark">
                  {categoryChildren.map((x) => (
                    <Link key={x.categoryId} href={buildUrl({ category: x })} passHref>
                      <Dropdown.Item>{x.name}</Dropdown.Item>
                    </Link>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            )}
          </Col>

          {/*<Col className="text-end">*/}
          {/*  <Dropdown>*/}
          {/*    <Dropdown.Toggle variant="primary">Sortuj według</Dropdown.Toggle>*/}

          {/*    <Dropdown.Menu variant="dark">*/}
          {/*      <Dropdown.Item href="#/action-1">Alfabetycznie</Dropdown.Item>*/}
          {/*      <Dropdown.Item href="#/action-1">Nowości</Dropdown.Item>*/}
          {/*      <Dropdown.Item href="#/action-1">Cenie rosnąco</Dropdown.Item>*/}
          {/*    </Dropdown.Menu>*/}
          {/*  </Dropdown>*/}
          {/*</Col>*/}
        </Row>
        <Row>
          <Col md={12}>
            <Row>
              {products.map((x) => (
                <ProductCard key={x.id} product={x} />
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export async function getStaticProps(context) {
  const { params } = context;
  const slug = params.params[params.params.length - 1];

  const categories = await getCategories();
  const category = categories.filter((x) => x.slug === slug)?.[0];

  if (!category) {
    return {
      notFound: true,
    };
  }

  const products = await getProducts({}, category.categoryId);

  const categoryPath = [category];
  const categoriesDict = categories.reduce((p, c) => {
    p[c.categoryId] = c;
    return p;
  }, {});

  let parent = categoryPath[categoryPath.length - 1].parent;
  while (parent > 0) {
    categoryPath.push(categoriesDict[parent]);
    parent = categoriesDict[parent].parent;
  }

  return {
    props: {
      products: products.map(transformProduct),
      category,
      categoryChildren: categories.filter((x) => x.parent === category.categoryId),
      categoryPath: categoryPath.reverse(),
    },
    revalidate: 1200,
  };
}

export async function getStaticPaths() {
  const categories = (await getCategories()).reduce((p, c) => {
    p[c.categoryId] = c;
    return p;
  }, {});

  const paths = Object.values(categories).map((category) => ({
    params: { params: [categories[category.parent]?.slug, category.slug].filter((x) => x) },
  }));

  // We'll pre-render only these paths at build time.
  // { fallback: false } means other routes should 404.
  return { paths, fallback: false };
}

export default Products;
